import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import AssignmentsControlQuestion from './AssignmentsControlQuestion';
import { answersAction } from '../../modules/answers/answers.action';
import { AppState } from '../../store';
import { TCtrlAnswer, convertToControlAnswer } from './AssignmentsControlQuestion.state';
import { TAnswerControlSubmit, TControlAnswer } from '../../types/assignments';

const AssignmentsControlQuestionContainer = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const { currentGroup } = useSelector((state: AppState) => state.pages.groupsClass);

  const getTaskDetail = (id: string, groupId: number) => {
    dispatch(answersAction.getDetailTaskForStudent({ id, isSaved: false, groupId }));
  };
  const targetMonth = useLocation<{ month: number }>();
  // const checkFalse = (data: any) => data !== null && data !== undefined;
  const saveCtrlAnswers = (rawAnswers: TCtrlAnswer[]) => {
    const answers: TControlAnswer[] = convertToControlAnswer(rawAnswers);
    dispatch(answersAction.saveControlAnswers({ id, answers }));
  };
  const handleSubmitAnswerControlTask = useCallback(
    (data: TAnswerControlSubmit) => {
      dispatch(answersAction.submitAnswerControlTask(data));
    },
    [dispatch],
  );
  const answersState = useSelector((state: AppState) => state.pages.answers);
  const { currentUser } = useSelector((state: AppState) => state.pages.auth);

  const getResults = (id: string, sid: string) => {
    dispatch(answersAction.getResultAssignmentOneStudent({ id, sid }));
  };

  const dataStudentAnswer = useSelector((state: AppState) => state.pages.answers.dataSimulations?.studentSimulation);

  return (
    <AssignmentsControlQuestion
      assignmentId={id}
      getTaskDetail={getTaskDetail}
      answersState={answersState}
      saveCtrlAnswers={saveCtrlAnswers}
      targetMonth={targetMonth.state ?? 10}
      currentGroup={currentGroup}
      getResults={getResults}
      currentUser={currentUser}
      dataStudentAnswer={dataStudentAnswer}
      handleSubmitAnswerControlTask={handleSubmitAnswerControlTask}
    />
  );
};

export default AssignmentsControlQuestionContainer;
